import { Divider, Stack, Typography } from '@mui/material';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { CompetitorPriceRow } from '@retail/products/components';
import { useFetchMgItemAssortmentCompetitorPrices } from '@retail/products/data-access';
import { useProductsTFunction } from '@retail/products/i18n';
import { competitorMgItemPriceFromDto } from '@retail/products/types';
import { Retailer } from '@retail/retailer/types';
import { useMemo } from 'react';

interface Props {
  mgItemNumber: number;
}

export const MgItemCompetitorPrices = ({ mgItemNumber }: Props) => {
  const t = useProductsTFunction();
  const { selectedOrgUnitAssortment } = useSelectedOrgUnit();
  const { retailerLogoBaseUrl } = useMgPrisConfig();

  const { data: competitorPricesDto } = useFetchMgItemAssortmentCompetitorPrices({
    mgItemNumber,
    assortmentId: selectedOrgUnitAssortment.assortmentId,
  });

  const competitorPrices = useMemo(
    () =>
      (competitorPricesDto ?? [])
        .map(competitorMgItemPriceFromDto)
        .sort((a, b) => (a.price && !b.price ? -1 : !a.price && b.price ? 1 : 0)),
    [competitorPricesDto]
  );

  if (!competitorPrices.length) {
    return <Typography p={2}>{t('products.prices.competitors.noCompetitorPrices')}</Typography>;
  }

  return (
    <Stack divider={<Divider flexItem />}>
      {competitorPrices.map((competitorPrice) => (
        <CompetitorPriceRow
          key={`${competitorPrice.retailerNumber}-${competitorPrice.storeNumber}`}
          competitorPrice={competitorPrice}
          logoUrl={Retailer.getCircularLogoUrl(competitorPrice.urlName, retailerLogoBaseUrl)}
        />
      ))}
    </Stack>
  );
};
